import styled from 'styled-components';

export const CannotDeletePromptModalWrapper = styled.div`
    position: relative;
    display: flex;
    padding: 48px 16px 16px;
    flex-direction: column;
    background-color: ${(props) => props.theme.colors.white};
    width: 798px;
    height: 453px;
    border-radius: 8px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const CannotDeletePromptModalCloseButton = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    fill: ${props => props.theme.colors.clearGray};
`;

export const ContentAlert = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
    justify-content: center;
`;

export const AlertTitle = styled.div`
    order: 0;
    font-weight: bold;
    font-family: ${(props) => props.theme.fonts.family.inter}
`;

export const AlertMessage = styled.div`
    order: 1;
    font-family: ${(props) => props.theme.fonts.family.inter}
`;

export const ListAgentsCounterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0px;
`;

export const ListAgentsCounterTitle = styled.div`
    ${(props) => props.theme.fonts.variant.semiBold()};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    color: ${(props) => props.theme.colors.darkGray};
`;

export const ListAgentsCounterNumber = styled.div`
    ${(props) => props.theme.fonts.variant.regular()};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    color: ${(props) => props.theme.colors.darkGray};
`;

export const ListAgentsWrapper = styled.div`
    flex: 1;
    padding: 8px;
    margin-bottom: 16px;
    border-radius: 8px;
    background: ${(props) => props.theme.colors.backgroundFafafa};
    overflow: hidden;
`;

export const ListAgentsContainer = styled.div`
    height: 100%;
    padding: 8px;
    border-radius: 8px;
    background: ${(props) => props.theme.colors.white};
`;

export const ListAgentsContainerItems = styled.div`
    height: 100%;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.clearGray};
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 100%; /* Asegura que el contenedor no se desborde */

    /* Estilos para el scrollbar en navegadores basados en WebKit (Chrome, Edge, Safari) */
    &::-webkit-scrollbar {
        width: 8px; /* Ancho del scrollbar */
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: #2f2f2f; /* Color del scrollbar */
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #1f1f1f; /* Color al pasar el mouse */
    }
`;

export const ListAgentsItem = styled.div`
    display: flex;
    padding: 9px 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background-color: ${(props) => props.theme.colors.backgroundFafafa};
    border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
    color: ${(props) => props.theme.colors.darkGray};
`;

export const AgentAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AgentName = styled.div`
    ${(props) => props.theme.fonts.variant.regular()};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
`;

export const AgentTeam = styled.div`
    text-overflow: ellipsis;
    ${(props) => props.theme.fonts.variant.light()};
    font-size: 10px;
    font-style: normal;
    line-height: normal;
    color: ${(props) => props.theme.colors.clearGray};
`;

export const ActionsWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: flex-end;
`;